import { Checkbox } from '@cian/ui-kit';
import { ChangeEvent, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { InlineFilter } from 'shared/components/InlineFilter';
import { useFilterChangeCallback } from 'shared/hooks';
import { selectIsNotFirstFloorFilter } from 'shared/selectors/advancedFilters';

export const IsNotFirstFloorContainer = () => {
  const { label, value } = useSelector(selectIsNotFirstFloorFilter);

  const onChange = useFilterChangeCallback();

  const handleChange = useCallback(
    (_: ChangeEvent<HTMLInputElement>, newValue: boolean) => {
      onChange({ action: 'setIsFirstFloor', arguments: [newValue ? false : null] });
    },
    [onChange],
  );

  return (
    <InlineFilter>
      <Checkbox label={label} checked={value} onChange={handleChange} />
    </InlineFilter>
  );
};
